import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const ACCEPT_FORM_OVERRIDE_REQUEST = 'ACCEPT_FORM_OVERRIDE_REQUEST';
export const ACCEPT_FORM_OVERRIDE_SUCCESS = 'ACCEPT_FORM_OVERRIDE_SUCCESS';
export const ACCEPT_FORM_OVERRIDE_FAILURE = 'ACCEPT_FORM_OVERRIDE_FAILURE';
export const OPEN_FORM_OVERRIDE_MODAL = 'OPEN_FORM_OVERRIDE_MODAL';
export const CLOSE_FORM_OVERRIDE_MODAL = 'CLOSE_FORM_OVERRIDE_MODAL';
export const OPEN_CANCEL_FORM_OVERRIDE_MODAL = 'OPEN_CANCEL_FORM_OVERRIDE_MODAL';
export const CLOSE_CANCEL_FORM_OVERRIDE_MODAL = 'CLOSE_CANCEL_FORM_OVERRIDE_MODAL';

function request() {
  return {
    type: ACCEPT_FORM_OVERRIDE_REQUEST,
    isSavingValidationOverrides: true,
  };
}

function receive(validationResult) {
  return {
    type: ACCEPT_FORM_OVERRIDE_SUCCESS,
    isSavingValidationOverrides: false,
    validationResult,
    validationOverridesError: null
  };
}

function reject(validationOverridesError) {
  return {
    type: ACCEPT_FORM_OVERRIDE_FAILURE,
    isSavingValidationOverrides: false,
    validationOverridesError
  };
}

function openModal() {
  return {
    type: OPEN_FORM_OVERRIDE_MODAL
  };
}

function closeModal() {
  return {
    type: CLOSE_FORM_OVERRIDE_MODAL
  };
}

function openCancelModal() {
  return {
    type: OPEN_CANCEL_FORM_OVERRIDE_MODAL
  };
}

function closeCancelModal() {
  return {
    type: CLOSE_CANCEL_FORM_OVERRIDE_MODAL
  };
}

export function showFormOverrideModal() {
  return dispatch => dispatch(openModal());
}

export function hideFormOverrideModal() {
  return dispatch => dispatch(closeModal());
}

export function showCancelFormOverrideModal() {
  return dispatch => dispatch(openCancelModal());
}

export function hideCancelFormOverrideModal() {
  return dispatch => dispatch(closeCancelModal());
}

export function acceptFormOverride(formId, data) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .acceptFormOverride(formId, data)
      .then((response) => {
        dispatch(receive(response.data));
        toastr.success('Success', 'Your form override change has been accepted.');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}

export function cancelFormOverride(formId) {
  return (dispatch) => {
    dispatch(request());

    const data = {
      isDraft: false,
      override: false,
      valid: false
    };

    const promise = () => ApiService
      .acceptFormOverride(formId, data)
      .then((response) => {
        dispatch(receive(response.data));
        dispatch(hideCancelFormOverrideModal());
        toastr.success('Success', 'Your form override change has been accepted.');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
